let scrolled = 0;
let timer;

const buttonToTop = document.querySelector('.buttonToTop');

window.onload = function () {
  buttonToTop.addEventListener('click', goUp);
  window.addEventListener('scroll', trackScroll);
};

function goUp() {
  scrolled = window.pageYOffset;
  scrollToTop();
}

function scrollToTop() {
  if (scrolled > 0) {
    window.scrollTo(0, scrolled);
    scrolled = scrolled - 100;
    timer = setTimeout(scrollToTop, 20);
  } else {
    clearTimeout(timer);
    window.scrollTo(0, 0);
  }
}

function trackScroll() {
  scrolled = window.pageYOffset;
  const coords = document.documentElement.clientHeight;

  if (scrolled > coords) {
    buttonToTop.classList.remove('disable-btn');
  } else {
    buttonToTop.classList.add('disable-btn');
  }
}
